import WhatsAppEnquiryForm from "@/components/feature/WhatsAppEnquiryForm";

export default function AboutWhatsAppSection() {
  return (
    <section className="py-16 md:py-24 bg-[#EAF5E1]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left: Info */}
          <div>
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-white px-3 py-1.5 rounded-full mb-4 border border-[#7FBF3F]/20">
              Enquire Now
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-5 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Let's Build Something Great Together
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-8" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Whether you're looking for a premium villa plot, a residential layout, or expert property consultation — our team is ready to guide you every step of the way.
            </p>
            <div className="space-y-4">
              {[
                { icon: "ri-shield-check-line", title: "Verified Documentation", desc: "All projects come with clear titles and legal approvals." },
                { icon: "ri-map-pin-2-line", title: "Prime Locations", desc: "Strategically located on Sarjapur Road, Bangalore." },
                { icon: "ri-customer-service-2-line", title: "Dedicated Support", desc: "Personal assistance from enquiry to registration." },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-4 bg-white rounded-xl p-4 border border-[#7FBF3F]/10">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#EAF5E1] rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#7FBF3F] text-base`}></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-[#1B2A4A] mb-0.5">{item.title}</p>
                    <p className="text-xs text-gray-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Form */}
          <div>
            <WhatsAppEnquiryForm />
          </div>
        </div>
      </div>
    </section>
  );
}
